/**
 * Sprint 17 ч.2 — «человек пришёл за ключом для i5G». Вход через Google и
 * Telegram уводит браузер со страницы, поэтому метка живёт в localStorage и
 * снимается, когда /5g показал ключ.
 *
 * В метке — время её постановки: живёт она сутки. Бросил вход на полпути и
 * вернулся через неделю — это уже обычный вход, а не «пришёл за 5G». Старое
 * значение `'1'` читается как время 1 мс от эпохи, то есть просроченная
 * метка: до выката формата метки на проде не было, отдельной ветки не нужно.
 */
export const FIVEG_INTENT_STORAGE_KEY = 'igra_fiveg_intent'
export const FIVEG_INTENT_TTL_MS = 24 * 60 * 60 * 1000

function storage(): Storage | null {
  try {
    return window.localStorage
  } catch {
    return null
  }
}

export function storeFiveGIntent(): void {
  try {
    storage()?.setItem(FIVEG_INTENT_STORAGE_KEY, String(Date.now()))
  } catch {
    // хранилище запрещено — человек вернётся по ссылке сам
  }
}

export function hasFiveGIntent(): boolean {
  let raw: string | null | undefined
  try {
    raw = storage()?.getItem(FIVEG_INTENT_STORAGE_KEY)
  } catch {
    return false
  }
  if (raw === null || raw === undefined) return false
  const storedAt = Number(raw)
  const age = Date.now() - storedAt
  if (Number.isFinite(storedAt) && age >= 0 && age < FIVEG_INTENT_TTL_MS) return true
  clearFiveGIntent()
  return false
}

export function clearFiveGIntent(): void {
  try {
    storage()?.removeItem(FIVEG_INTENT_STORAGE_KEY)
  } catch {
    // нечего снимать
  }
}
